/** Normalização e discriminação CPF×CNPJ para o CNPJ alfanumérico (SCR-972). */

export const normalizeCpfCnpj = (value: string): string =>
  (value ?? '').toUpperCase().replace(/[^0-9A-Z]/g, '')

export const isCnpj = (value: string): boolean => {
  const normalized = normalizeCpfCnpj(value)

  return /[A-Z]/.test(normalized) || normalized.length === 14
}
